import axios from 'axios';
import { Language } from '../models';

export const LANGUAGE_CODES: string[] = ['pl', 'en', 'chi', 'nl', 'de', 'fr'];

export const getLanguages = () => {
    return axios.get<Language[]>(`Languages`);
};

export const redirectToLanguageHome = (langCode: string): void => {
    localStorage.setItem('lang', langCode);
    window.location.href = `/${langCode}`;
};

export const getLanguageCode = (): string => {
    const lang = localStorage.getItem('lang');

    if (lang) {
        return lang;
    }

    const host = window.location.hostname.toLowerCase();

    if (host.endsWith('.be') || host.endsWith('.fr') || host.endsWith('.lu')) {
        return 'fr';
    }

    if (host.endsWith('.nl')) {
        return 'nl';
    }

    return 'en';
};

const getLanguageCodeFromUrl = (): string | null => {
    const segment = window.location.pathname?.split('/')[1]?.toLowerCase();

    return segment && LANGUAGE_CODES.includes(segment) ? segment : null;
};

// Saves the language on the first visit, before anything renders. Components read the saved `lang` in their own
// effects, which run before the app's own effect that saves it, so without this they would see no language on a
// first visit and skip loading their language-dependent content (e.g. the footer from the CMS).
// Order: the saved language, the language in the address (`/en/...`), the default for the host.
export const ensureLanguageCode = (): string => {
    const savedLanguageCode = localStorage.getItem('lang');

    if (savedLanguageCode) {
        return savedLanguageCode;
    }

    const languageCode = getLanguageCodeFromUrl() ?? getLanguageCode();
    localStorage.setItem('lang', languageCode);

    return languageCode;
};
